import React from 'react';

const Footer = () => {
  return (
    <footer className="py-12 px-6 md:px-12 max-w-[1440px] mx-auto border-t border-gray-100">
      <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-gray-500">
        <span className="font-medium text-gray-900 text-lg">CraftCloud 云作</span>
        <div className="flex gap-8">
          <button className="hover:text-black transition-colors">Privacy</button>
          <button className="hover:text-black transition-colors">Terms</button>
          <button className="hover:text-black transition-colors">About</button>
        </div>
        <span>&copy; 2026</span>
      </div>
    </footer>
  );
};

export default Footer;
